export default {
    table: {
        tableClass: '',
        ascendingIcon: 'fa fa-chevron-up',
        descendingIcon: 'fa fa-chevron-down',
    },
    paginationInfo:{
        infoClass: "pagination-info"
    }
}
